import axiosClient from '../axiosClient';

const categoryServiceAPI = {
    async getList(params) {
        const url = `/category_service`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async findOne(id, params) {
        const url = `/category_service/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async create(data) {
        const url = `/category_service`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async update(id, data) {
        const url = `/category_service/${id}`;
        const resp = await axiosClient.put(url, data);
        return resp;
    },

    async remove(id) {
        const url = `/category_service/${id}`;
        const resp = await axiosClient.delete(url);
        return resp;
    },

    async removeMulti(params) {
        const url = `/category_service`;
        const resp = await axiosClient.delete(url, { params });
        return resp;
    },
};

export default categoryServiceAPI;
